module.exports = __webpack_public_path__ + "static/media/map.f56baf55.svg";